import React from "react"
import { graphql } from 'gatsby'
import { Helmet } from "react-helmet"

const Seo = ({
	title,
	description = ''
}) => {

	const formattedTitle = title ? `${title} – Proof` : 'Proof'

  return (
    <Helmet title={formattedTitle}>
      <meta name="description" content={description} />

      {title && <meta property="og:title" content={formattedTitle} />}
			{title && <meta name="twitter:title" content={formattedTitle} />}

      {description && <meta property="og:description" content={description} />}
			{description && <meta name="twitter:description" content={description} />}

			<meta property='og:url' content='https://proof.tech/'/>

			{/* <meta name="robots" content="noindex" /> */}
    </Helmet>
  )
}

export default Seo

export const query = graphql`
	fragment Seo on PrismicSeo {
		data {
      meta_description {
        text
      }
    }
	}
`